/**
 * Opt-in map viewport loading for /leads (map-data bbox queries).
 * Slim pin shape and lead-date fetch: see leadsMapData.js.
 *
 * Enable via any of:
 * - REACT_APP_LEADS_MAP_VIEWPORT_FETCH=true
 * - URL ?mapViewport=1 or ?mapViewport=true
 * - localStorage leadsMapViewportFetch = "1" or "true"
 *
 * @param {URLSearchParams} searchParams from useSearchParams()
 */
export function isLeadsViewportMapFetchEnabled(searchParams) {
  if (process.env.REACT_APP_LEADS_MAP_VIEWPORT_FETCH === "true") {
    return true;
  }
  try {
    const q = searchParams?.get?.("mapViewport");
    if (q === "1" || q === "true") return true;
  } catch {
    /* ignore */
  }
  try {
    const v = localStorage.getItem("leadsMapViewportFetch");
    if (v === "1" || v === "true") return true;
  } catch {
    /* ignore */
  }
  return false;
}
